<div class="flex flex-col flex-auto min-w-0">
    <!-- Header -->
    <!-- Main -->
    <div class="border-t -mt-px py-2">
        <div class="w-full max-w-screen-xl mx-auto">
            <div class="py-2">
                <div
                    class="grid grid-cols-1 sm:grid-cols-6 gap-6 w-full min-w-0 p-5"
                >
                    <div
                        class="sm:col-span-4 bg-card shadow border border-gray-100 rounded-2xl overflow-hidden"
                    >
                        <app-well-healthiness-chart
                            [data]="wellsHealthinessSummary"
                            [activeCategory]="selectedWellHealthinessStatus"
                            (categorySelected)="onCategorySelected($event)"
                        ></app-well-healthiness-chart>
                    </div>

                    <div
                        class="sm:col-span-2 flex flex-col gap-6"
                    >
                        <!-- String Healthiness Card -->
                        <div class="bg-card shadow border border-gray-100 rounded-2xl overflow-hidden flex flex-col flex-none bg-white">
                            <app-well-healthiness-info
                                [data]="stringsHealthinessSummary"
                            ></app-well-healthiness-info>
                        </div>

                        <!-- Risk Ranking Card -->
                        <div class="bg-card shadow border border-gray-100 rounded-2xl overflow-hidden flex flex-col flex-auto bg-white">
                            <div class="row card-header px-4 py-3 border-b">
                                <div class="text-[15px] font-medium tracking-tight truncate m-0">
                                    Risk Ranking
                                </div>
                            </div>

                            <div class="flex flex-col flex-none bg-white">
                                <div *ngFor="let item of wellsHealthinessSummary?.riskRankingItems" class="px-4 py-3 border-b border-gray-100 last:border-b-0 flex items-center justify-between transition-colors hover:bg-gray-50">
                                    <span class="text-[13px] text-gray-600">{{ item.category | titlecase }}</span>
                                    <span class="text-[14px] font-medium text-gray-900">{{ item.count }}</span>
                                </div>
                            </div>
                        </div> <!-- End Risk Ranking Card -->

                    </div>

                    <div
                        id="string-summary-section"
                        class="sm:col-span-6 bg-card shadow rounded-2xl overflow-hidden p-6"
                    >
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
